<form [formGroup]="searchForm" >
    <div class="ui-g ui-fluid search-toolbar-container" *ngIf="searchForm">
        <p-accordion>
            <p-accordionTab [selected]="true">

                <div class="ui-g-12 search-toolbar-box-container" style="padding-bottom: 0;">

                  <!-- COLONNA 1 -->
                  <div class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-analysis" style="border-right: #edf0f5 2px solid; padding-bottom: 100px;">
                    <div class="row ui-g-12">
                      <div class="ui-g-12">{{ 'loyalty.info_customers_nation' | translate}}</div>
                        <div class="ui-g-12">
                          <p-dropdown [options]="nationItems" [style]="{ 'width': '100%'}" formControlName="nation"></p-dropdown>
                      </div>
                    </div>
                  </div>

                  <!-- COLONNA 2 -->
                  <div class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-analysis" style="border-right: #edf0f5 2px solid;">
                    <div class="row ui-g-12">
                      <div class="ui-g-12">{{ 'loyalty.info_customers_name' | translate}}</div>
                        <div class="ui-g-12 search-toolbar-input">
                          <input [style]="{ width: '80% !important' }" name="card" type="text" pInputText formControlName="name" autocomplete="off" />
                        </div>
                    </div>
                    <div class="row ui-g-12">
                        <div class="ui-g-12">{{ 'loyalty.info_customers_surname' | translate}}</div>
                        <div class="ui-g-12 search-toolbar-input">
                          <input [style]="{ width: '80% !important' }" name="card" type="text" pInputText formControlName="surname" autocomplete="off" />
                        </div>
                    </div>
                  </div>

                  <!-- COLONNA 3 -->
                  <div class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-analysis" style="border-right: #edf0f5 2px solid;">
                    <div class="row ui-g-12">
                      <div class="ui-g-12">{{ 'loyalty.info_customers_mobile' | translate}}</div>
                        <div class="ui-g-12 search-toolbar-input">
                          <input [style]="{ width: '80% !important' }" name="card" type="text" pInputText formControlName="mobile" autocomplete="off"/>
                        </div>
                    </div>
                    <div class="row ui-g-12">
                      <div class="ui-g-12">{{ 'loyalty.info_customers_telephone' | translate}}</div>
                      <div class="ui-g-12 search-toolbar-input">
                        <input [style]="{ width: '80% !important' }" name="card" type="text" pInputText formControlName="telephone" autocomplete="off" />
                      </div>
                    </div>
                  </div>

                  <!-- COLONNA 4 -->
                  <div class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-analysis" style="border-right: #edf0f5 2px solid;">
                    <div class="row ui-g-12">
                      <div class="ui-g-12">{{ 'loyalty.info_customers_email' | translate}}</div>
                      <div class="ui-g-12 search-toolbar-input">
                        <input [style]="{ width: '80% !important' }" name="card" type="text" pInputText formControlName="email" autocomplete="off" />
                      </div>
                    </div>
                    <div class="row ui-g-12">
                      <div class="ui-g-12">{{ 'loyalty.info_customers_date_birth' | translate}}</div>
                      <div class="ui-g-12 search-toolbar-input">
                        <app-kv-calendar
                        [inputName]="'date_birth'"
                        [formData]="searchForm"
                        [maxDate]="today"
                        >
                        </app-kv-calendar>
                      </div>
                    </div>
                  </div>

                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-3"></div>
        <div class="ui-g-3">
          <button
            pButton type="button"
            class="k-generic-btn"
            style="width: 100% !important;"
            [label]="'common.reset' | translate"
            (click)="resetFilters()" >
          </button>
        </div>
        <div class="ui-g-3">
          <button
            [disabled]="!searchForm.valid"
            pButton type="button"
            class="k-generic-btn"
            style="width: 100% !important;"
            icon="fa fa-search"
            iconPos="left"
            [label]="'common.apply' | translate"
            (click)="search($event)">
          </button>
        </div>
      <div class="ui-g-3"></div>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-info-customers/loyalty-info-customers-filter.component.html